import type { FaireThemeEntity } from "../../entity_types/theme";

export const board_demo_r_wd64rb2zkz_thi_dc767d9ede: FaireThemeEntity = {
  token: "board_demo_r_wd64rb2zkz_thi_dc767d9ede",
  type: "theme",
  retailerToken: "r_wd64rb2zkz",
  name: "Faith-Inspired Apparel and Keepsake Books",
  description:
    "This selection combines faith-forward apparel from Elevated Faith with inspiring keepsake books from Cottage Door Press, directly reflecting your most consistent buying patterns.",
  bgColor: "#F4EDE3",
  productTokens: [],
  coverImageUrl:
    "https://cdn.faire.com/fastly/b075145b7f8834d0a29f8e1924c295f2e696d59053c22acc307974e3de4dc44f.jpeg",
  thumbnailImageUrls: [
    "https://cdn.faire.com/fastly/b075145b7f8834d0a29f8e1924c295f2e696d59053c22acc307974e3de4dc44f.jpeg",
    "https://cdn.faire.com/fastly/98f166ace4ead9680cf5ac398b8465e08ab5a0aeb4f44270efc05223b53dad95.jpeg",
    "https://cdn.faire.com/fastly/b1f930d7e2cff430e6a66d352a4b346b55134809bcfc9407e0d3abe28e6d19f5.jpeg",
    "https://cdn.faire.com/fastly/8bc834c00fd306fe0276a48b4708a1c85e604cd236a779af632b812da759227f.jpeg",
    "https://cdn.faire.com/fastly/4321390e4dbff2b6f9c27f243056012483ffdaec6e80d23c09e76e384333c2ed.jpeg",
    "https://cdn.faire.com/fastly/7fed7429374c2e448bcb191d78172aa716ba444dbf3b81a2a3ead8624394712c.jpeg",
  ],
  itemCount: 16,
  source: "eric_themes_ideas",
  teaser: "thi_dc767d9ede",
  meta: {
    source: "mock",
    importedAt: "2026-04-19T23:00:00.000Z",
    importedBy: "board-demo-canonicalize",
  },
};
